import ReactDOM from 'react-dom';
export var unstable_batchedUpdates = ReactDOM.unstable_batchedUpdates;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-query/es/react/reactBatchedUpdates.js
// module id = 1680
// module chunks = 31